/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type NewsManagementListNewsRequest = {
    perPage?: number | null;
    page?: number | null;
    keyword?: string | null;
    sort?: string | null;
    direction?: NewsManagementListNewsRequest.direction | null;
    category?: string | null;
    status?: string | null;
    title?: string | null;
};

export namespace NewsManagementListNewsRequest {

    export enum direction {
        ASC = 'asc',
        DESC = 'desc',
    }


}

